import { Button, Container, CssBaseline, Paper, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { ResetPasswordActions, ResetPasswordStoreStates } from '.'
import { Form } from './styles'

type OwnProps = {}
type ResetPasswordProps = OwnProps & ResetPasswordStoreStates & ResetPasswordActions

const ResetPassword = (props: ResetPasswordProps) => {
  const { auth } = props
  const { resettingPassword } = auth

  const [email, setEmail] = useState('')
  const [isEmpty, setIsEmpty] = useState(true)

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (isEmpty) return
    props.resetPassword(email)
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper sx={{ mt: 8, p: 2 }}>
        <Typography align="center" color="textPrimary" variant="h5">
          パスワードのリセット
        </Typography>

        <Typography align="center" color="textPrimary" variant="subtitle1">
          登録されたメールアドレスに
          <br />
          パスワードリセット用のメールを送信します。
        </Typography>

        <Form noValidate onSubmit={(e) => onSubmit(e)}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="メールアドレス"
            type="email"
            value={email}
            onChange={({ target }) => {
              setEmail(target.value)
              setIsEmpty(target.value === '')
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isEmpty || resettingPassword}
            sx={{ mt: 3, mb: 2 }}>
            送信
          </Button>
          {resettingPassword && (
            <Typography align="center" color="secondary" component="p">
              メールを送信しました。
            </Typography>
          )}
        </Form>
      </Paper>
    </Container>
  )
}

export default ResetPassword
